import { render, staticRenderFns } from "./UndergroundResources.vue?vue&type=template&id=e6323794"
import script from "./UndergroundResources.vue?vue&type=script&lang=ts"
export * from "./UndergroundResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports